module.exports = __webpack_public_path__ + "static/media/plus-hexagon.aa162674.svg";